/* Shared pre-paint layout bootstrap. Keep this classic script ES5-compatible:
 * older mobile engines must not depend on Next.js hydration or CSS typed
 * division to scale the fixed-size Figma boards. No UA or keyboard sniffing. */
(function (window, document) {
  'use strict';
  if (window.__glydeLayoutCompat) return;
  window.__glydeLayoutCompat = true;

  var root = document.documentElement;
  var previousWidth = 0;
  var pending = false;

  function validWidth(value) {
    return typeof value === 'number' && isFinite(value) && value > 0;
  }

  function update() {
    pending = false;
    var clientWidth = root.clientWidth;
    var innerWidth = window.innerWidth;
    var width = validWidth(clientWidth) ? clientWidth : innerWidth;
    // CSS 100vw normally includes a desktop scrollbar. Preserve that small
    // difference, but don't mistake an overflow-inflated innerWidth for the
    // layout viewport on affected mobile browsers.
    if (validWidth(clientWidth) && validWidth(innerWidth) &&
        innerWidth >= clientWidth && innerWidth - clientWidth <= 32) {
      width = innerWidth;
    }
    if (!validWidth(width) || width === previousWidth) return;
    root.style.setProperty('--glyde-desktop-scale', String(Math.min(width, 1920) / 1920));
    root.style.setProperty('--glyde-mobile-scale', String(width / 1080));
    previousWidth = width;
  }

  function schedule() {
    if (pending) return;
    pending = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(update);
    else window.setTimeout(update, 16);
  }

  update();
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('DOMContentLoaded', schedule);
}(window, document));
